import Vue from "vue";

export default {
  state: {
    centers: [],
  },
  getters: {
    // Getter to retrieve centers
    getCenters: (state) => {
      return state.centers;
    },
    // Getter to lookup a center by its id
    getCenterById: (state) => (id) => {
      return state.centers.find((center) => center.id === id);
    },
  },
  mutations: {
    // Mutation to update centers
    SET_CENTERS(state, centers) {
      state.centers = centers;
    },
  },
  actions: {
    // Action to fetch centers from the server
    fetchCenters({ commit }) {
      return Vue.axios
        .get("/staff/centers")
        .then((response) => {
          commit("SET_CENTERS", response.data);
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
